import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  description: {
    color: theme.palette.common.gray800,
  },
  rows: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.common.gray200,
    borderRadius: theme.misc.borderRadius,
    padding: theme.spacing(2),
  },
  row: {
    backgroundColor: theme.palette.common.white,
    border: theme.customBorders.gray200,
    borderRadius: theme.misc.borderRadius,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  name: {
    color: theme.palette.common.gray800,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  deleteButton: {
    color: theme.palette.common.gray600,
  },
  addButton: {
    color: theme.palette.common.blue400,
    marginTop: theme.spacing(2),
  },
  requirementSection: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: theme.customBorders.gray200,

    // FormControlLabel's default -11px offset pushes the switch left of the
    // card's content edge.
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
    },
  },
  requirementDescription: {
    display: 'block',
    color: theme.palette.common.gray600,
  },
  requirementFields: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1.5),
    maxWidth: 480,
  },
  submissionsSelect: {
    flex: 1,
    minWidth: 0,
  },
  countInput: {
    width: 96,
    flexShrink: 0,
  },
}));
